import { render } from "./TheResolutionBar.vue?vue&type=template&id=404f3ef0&scoped=true&ts=true"
import script from "./TheResolutionBar.vue?vue&type=script&lang=ts"
export * from "./TheResolutionBar.vue?vue&type=script&lang=ts"

import "./TheResolutionBar.vue?vue&type=style&index=0&id=404f3ef0&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404f3ef0"]])

export default __exports__